export default {
  baseURL: "https://cs55.top",
};
